'use client'

import useIsMobile from '@/hooks/useIsMobile'
import { ArticleProps, ArticleSectionProps } from '@/widgets/landing-page-widgets/ArticleSection/schema'
import { Typography } from '@pw-tech/omni-ui'
import { useMemo, useRef } from 'react'
import CustomCarousel from '../CustomCarousel'
import Article from './Article'

const ArticleSection = ({ articleSectionData }: { articleSectionData: ArticleSectionProps }) => {
  const { isMobile } = useIsMobile()
  const sliderRef = useRef(null)
  const articles = articleSectionData?.articles

  const slidesToShow = useMemo(() => {
    if (isMobile) {
      return articles?.length <= 2 ? articles?.length : 1.5
    }
    return 4
  }, [articles?.length, isMobile])

  const arrows = isMobile ? !((articles?.length || 0) <= 2) : !((articles?.length || 0) <= 4)

  return (
    <div className='py-6 md:py-[60px]'>
      <div className='max-w-6xl mx-auto px-4 md:px-6'>
        <Typography variant='heading2' weight='bold' color='#1b2124' className='mb-2 text-center'>
          {articleSectionData?.heading}
        </Typography>
        <Typography variant='heading4' color='#3d3d3d' className='text-center'>
          {articleSectionData?.subHeading}
        </Typography>
        <div className='mt-6 md:mt-12'>
          <CustomCarousel
            items={articles}
            renderCarouselItem={(item: ArticleProps) => <Article article={item} />}
            ref={sliderRef}
            slidesToShow={slidesToShow}
            arrows={arrows}
          />
        </div>
      </div>
    </div>
  )
}

export default ArticleSection
